import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PLATFORM } from '../../../constants';
export function transformValueToProductCardData(products, value) {
  return Object.keys(value).reduce(function (res, productId) {
    var cards = value[productId].map(function (_ref, idx) {
      var data = _ref.data;
      return {
        idx: idx,
        id: productId,
        label: products[productId].label + (value[productId].length > 1 ? " ".concat(idx + 1) : ''),
        productQuantity: data === null || data === void 0 ? void 0 : data.productQuantity,
        formData: data
      };
    });
    res[products[productId].platform] = res[products[productId].platform].concat(cards);
    return res;
  }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, PLATFORM.Evolution, []), PLATFORM.Advanced, []), PLATFORM.VmWare, []), PLATFORM.MlSpace, []), PLATFORM.Test, []));
}